import { render, staticRenderFns } from "./NavbarWrapper.vue?vue&type=template&id=b20bafe4&"
import script from "./NavbarWrapper.vue?vue&type=script&setup=true&lang=js&"
export * from "./NavbarWrapper.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports